import React from "react";

export function ExperimentStatusFormatter(cellContent, row, rowIndex) {
  return (
    <>
      {row.experiment_status.toLowerCase() === "pending" ? (
        <span className="label label-lg label-light-danger label-inline">
          pending
        </span>
      ) : row.experiment_status.toLowerCase() === "completed" ? (
        <span className="label label-lg label-light-success label-inline">
          completed
        </span>
      ) : row.experiment_status.toLowerCase() === "requested" ? (
        <span className="label label-lg label-light-primary label-inline font-weight-bold py-4">
          requested
        </span>
      ) : row.experiment_status.toLowerCase() === "processing" ? (
        <span className="label label-lg label-light-warning label-inline font-weight-bold py-4">
          processing
        </span>
      ) : row.experiment_status.toLowerCase() === "error" ? (
        <span className="label label-lg label-light-warning label-inline font-weight-bold py-4">
          error
        </span>
      ) : (
        <span>{row.experiment_status.toLowerCase()}</span>
      )}
    </>
  );
}
